import { ApiHandlerNoApiParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { CarrierRulesMap, SavedShippingDataMap } from "@thkStore/Common/Types/Shipping/ShippingTypes";
import { getShippingOptions, ShippingOptionsApiResult } from "@thkStore/Services/ShippingService";

type HandlerType = ApiHandlerNoApiParameter<{ billToId?: string }, ShippingOptionsApiResult>;

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getShippingOptions(props.parameter.billToId);
    } catch (error) {
        logger.error("LoadShippingOptions failed: " + (error as Error).message);
        props.apiResult = {
            shippingTypeOptions: [],
            alternativeAddresses: [],
            savedShippingData: [],
            carrierRules: [],
        };
    }
};

export const DispatchToStore: HandlerType = props => {
    // Returns savedShippingData as a list
    const list = props.apiResult?.savedShippingData ?? [];
    const savedShippingData: SavedShippingDataMap = {};
    for (const item of list) {
        if (item?.carrierKey) {
            savedShippingData[item.carrierKey] = item.entries ?? [];
        }
    }

    const carrierRules: CarrierRulesMap = {};
    for (const rule of props.apiResult?.carrierRules ?? []) {
        if (rule?.carrierId) {
            carrierRules[rule.carrierId] = !!rule.alternativeAddressRequired;
        }
    }

    props.dispatch({
        type: "Shipping/LoadSavedShippingData",
        shippingTypeOptions:  props.apiResult?.shippingTypeOptions  ?? [],
        alternativeAddresses: props.apiResult?.alternativeAddresses ?? [],
        savedShippingData,
        carrierRules,
    });
};

export const chain = [RequestDataFromApi, DispatchToStore];

const loadShippingOptions = createHandlerChainRunner(chain, "LoadShippingOptions");
export default loadShippingOptions;
